import {Box, Button, Typography} from "@mui/material";
import _ from "lodash";
import React, {memo} from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ImportantDevicesOutlined as ImportDevicesIcon,
  StorefrontOutlined as StorefrontIcon,
  PaymentOutlined as PaymentIcon,
} from "@mui/icons-material";
import {useHistory} from "react-router-dom";

const classes = {
  iconSuccess: {
    color: "#0FBF00",
    marginBottom: 3,
  },
  iconSize: {
    fontSize: "14px!important",
  },
};

interface ResultPageProps {
  data: any;
}

const ResultPage = (props: ResultPageProps) => {
  const { data = {} } = props;
  const history = useHistory();
  const { attributes } = data;
  const SuccessIcon = (
    <CheckCircleOutlineIcon fontSize="large" sx={classes.iconSuccess} />
  );

  const viewTerminal = () => {
    history.push(`/terminal?onboardingId=${attributes.OnboardingID}`);

  }
  const viewMerchant = () => {
    history.push(`/merchant?onboardingId=${attributes.OnboardingID}`);
  }
  const viewPOS = () => {
    history.push(`/pos?onboardingId=${attributes.OnboardingID}`);
  }

  return (
    <Box width="100%" display='flex' alignItems='center' flexDirection='column' textAlign="center">
      {SuccessIcon}
      <Typography sx={{ marginBottom: 3 }} align='left'>
        <br />
        {_.get(attributes, 'Status.Summary.merchantResult.nUpserted', 0)} Merchants were imported
        <br/>
        {_.get(attributes, 'Status.Summary.merchantResult.nModified', 0)} Merchants were modified
        <br/>
        {_.get(attributes, 'Status.Summary.posResult.nInserted', 0)} POS were imported
        <br/>
        {_.get(attributes, 'Status.Summary.terminalResult.nModified', 0)} Terminals configuration were updated
        <br/>
        {_.get(attributes, 'Status.Rejected', 0)} rows were skip due to errors
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Button
          variant="outlined"
          color="primary"
          sx={{ marginRight: "10px"}}
          onClick={viewTerminal}
          startIcon={<ImportDevicesIcon sx={classes.iconSize} />}
        >
          View Terminal
        </Button>
        <Button
          variant="outlined"
          color="primary"
          sx={{ marginRight: "10px"}}
          onClick={viewMerchant}
          startIcon={<StorefrontIcon sx={classes.iconSize} />}
        >
          View Merchant
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={viewPOS}
          startIcon={<PaymentIcon sx={classes.iconSize} />}
        >
          View POS
        </Button>
      </Box>
    </Box>
  );
}

export default ResultPage;
